import { render, staticRenderFns } from "./SharesList.vue?vue&type=template&id=7cfc137a&scoped=true&"
import script from "./SharesList.vue?vue&type=script&lang=js&"
export * from "./SharesList.vue?vue&type=script&lang=js&"
import style0 from "./SharesList.vue?vue&type=style&index=0&id=7cfc137a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfc137a",
  null
  
)

export default component.exports